import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconScanCode: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconScanCode"><Path d="M5 19H9V21H3V15H5V19Z" fill="currentColor"/><Path d="M21 21H15V19H19V15H21V21Z" fill="currentColor"/><Path d="M8 15H7V9H8V15Z" fill="currentColor"/><Path d="M11 15H9V9H11V15Z" fill="currentColor"/><Path d="M13 15H12V9H13V15Z" fill="currentColor"/><Path d="M15 15H14V9H15V15Z" fill="currentColor"/><Path d="M17 15H16V9H17V15Z" fill="currentColor"/><Path d="M9 5H5V9H3V3H9V5Z" fill="currentColor"/><Path d="M21 9H19V5H15V3H21V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconScanCode;
